<generic-search-results [showHeader]="false" [showCounter]="false" [title]="'mfa reset accounts'"
    [records]="mfaResetUsers" [displayedColumns]="userColumns" [selectableRecords]="false"
    [allowLocalFilter]="false"></generic-search-results>